var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1248_1098)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1248_1098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52204 3.85352H17.701C20.5242 3.85352 22.8129 6.14212 22.8129 8.96527V17.144C22.8129 19.9672 20.5242 22.2558 17.701 22.2558H9.52204C6.69882 22.2558 4.41016 19.9672 4.41016 17.144V8.96527C4.41016 6.14212 6.69882 3.85352 9.52204 3.85352ZM18.4725 9.21926C19.0371 9.21926 19.4948 8.76153 19.4948 8.1969C19.4948 7.63228 19.0371 7.17456 18.4725 7.17456C17.9077 7.17456 17.45 7.63228 17.45 8.1969C17.45 8.76153 17.9077 9.21926 18.4725 9.21926ZM13.6127 8.4541C11.0717 8.4541 9.01191 10.5139 9.01191 13.0547C9.01191 15.5955 11.0717 17.6552 13.6127 17.6552C16.1535 17.6552 18.2133 15.5955 18.2133 13.0547C18.216 11.8337 17.7322 10.6619 16.8688 9.79858C16.0054 8.93521 14.8336 8.45138 13.6127 8.4541ZM10.801 13.0531C10.801 14.6059 12.0597 15.8646 13.6125 15.8646C15.1652 15.8646 16.424 14.6059 16.424 13.0531C16.424 11.5003 15.1652 10.2416 13.6125 10.2416C12.0597 10.2416 10.801 11.5003 10.801 13.0531Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1248_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8024,
    height: 24.5625,
    fill: "white",
    transform: "translate(0.194336 0.787109)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1248_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7893,
    height: 24.5364,
    fill: "white",
    transform: "translate(0.194336 0.786621)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.b7ce6baf2ebd05aa0ef6a9aa54a128ca.svg";
export { ForwardRef as ReactComponent };